import React from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import CalendarComp from '../../CalendarComp/CalendarComp';

const PieChart = () => {

  const handleFilter = (value) => {
    // console.log("value", value);
  }
  // Sample data for the pie chart
  const data = {
    labels: [
      'Wallet Payment',
      'Promo Payment',
      'Cash Payment',
      'Other Payment'
    ],
    datasets: [
      {
        data: [30, 20, 25, 25], // Sample data values
        backgroundColor: [
          'rgba(255,99,132,0.6)', // Wallet Payment
          'rgba(54,162,235,0.6)', // Promo Payment
          'rgba(75,192,192,0.6)', // Cash Payment
          'rgba(153,102,255,0.6)', // Other Payment
        ],
        hoverBackgroundColor: [
          'rgba(255,99,132,0.8)', // Wallet Payment
          'rgba(54,162,235,0.8)', // Promo Payment
          'rgba(75,192,192,0.8)', // Cash Payment
          'rgba(153,102,255,0.8)', // Other Payment
        ],
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div className="no-flex-grow-card" style={{ flex: "1" }}>
      <div className="d-flex gap-1 align-items-center">
        <h1>Months Payment Details</h1>
        <CalendarComp
          view="month"
          sx={{ borderRadius: "20px" }}
          handleFilter={handleFilter}
        />
      </div>
      <div
        className="chart-container  "
        style={{ position: "relative", height: "400px", width: "100%" }}
      >
        <Pie data={data} options={options} />
      </div>
    </div>
  );
};

export default PieChart;
